<div class="dialog">
  <div class="dialog-head">
    <mat-icon>login</mat-icon>
    <h1>ACESSO SIMULADO</h1>
  </div>

  <div class="dialog-content custom-scroll">
    <mat-form-field appearance="outline">
      <mat-label>Email do usuário</mat-label>
      <input matInput [(ngModel)]="email" />
      <mat-icon matSuffix>mail</mat-icon>
    </mat-form-field>
  </div>

  <div class="bottom-buttons">
    <div (click)="setUserSimulado()" class="bottom-button">
      <mat-icon>login</mat-icon>
      <div class="text">ACESSAR USUÁRIO</div>
    </div>

    <div (click)="security.resetUserSimulado()" class="bottom-button">
      <mat-icon>restart_alt</mat-icon>
      <div class="text">RESETAR USUÁRIO</div>
    </div>
  </div>
</div>
